export default __webpack_public_path__ + "e8ae4609e36397f4fc25bd3d6afabd29.svg";